import { render, staticRenderFns } from "./SharingIndicator.vue?vue&type=template&id=7bc1a248"
import script from "./SharingIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharingIndicator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SharingIndicator.vue?vue&type=style&index=0&id=7bc1a248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports